export default "/assets/website/images/gold-background.png?3575d56671c015d1199c06d0acc3107e";